import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Subscription } from 'rxjs';
import { AppState } from 'src/app/app.reducer';
import { LocalStorageService } from 'src/app/common/services/local-storage.service';
import { PagesRoutes } from 'src/app/pages/page.routes';
import { environment as env } from 'src/environments/environment';
import { QuoteRoutes } from '../quote.routes';
import * as quoteActions from '../stores/quote.actions';
import * as wizardActions from '../stores/wizard.actions';
import { Step } from '../stores/wizard.reducer';
import { MultiProductRoutes } from 'src/app/multi_product/mp.routes';
 
@Injectable({
  providedIn: 'root',
})
export class WizardService implements OnDestroy {
  private stateSubscription: Subscription;

  private wizardStateSubscription: Subscription;

  routesPE = QuoteRoutes.ROUTES;

  routesBR = PagesRoutes.ROUTES;
  
  routesMP = MultiProductRoutes.ROUTES;
  
  private routes =  env.COUNTRY === 'pe' ? this.routesPE.Steps : env.COUNTRY === 'br' ? this.routesBR.Flow.Traditional.Steps : this.routesMP.Steps



  private quote;

  private steps: Step[] = [];

  private currentStep: Step;

  private showStepsSource = new BehaviorSubject(true);

  currentShowSteps = this.showStepsSource.asObservable();

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private localStorageService: LocalStorageService
  ) {
    this.stateSubscription = this.store.select('quote').subscribe((state) => {
      this.quote = state;
    });

    this.wizardStateSubscription = this.store.select('wizard').subscribe(({ steps }) => {
      this.steps = steps;
      this.localStorageService.set('steps', this.steps);
    });

    this.navigateToDoNotQuote();
    this.setWizardSteps();
  }

  private navigateToDoNotQuote() {
    if (this.router.url.includes('/quote/todo') || this.router.url.includes('/quote/steps')) {
      this.validateStep(this.router.url);
    }

    if (
      this.router.url.includes('/quote/steps') &&
      !this.router.url.includes('/quote/steps/main-data')
    ) {
      if (Object.keys(this.quote).length === 0)
        this.router.navigate([this.routes.StepMainData.fullPath]);
    }
  }

  private setWizardQuoteCurrentStep(currentStep: Step) {
    this.store.dispatch(quoteActions.setCurrentStep({ currentStep: currentStep.index }));
    this.store.dispatch(wizardActions.setCurrentStep({ currentStep: this.currentStep }));
  }

  public setWizardSteps() {
    if (!this.localStorageService.get('steps'))
      this.store.dispatch(wizardActions.setSteps({ steps: Object.values(this.routes) }));
    this.currentStep = this.routes.StepMainData;

    if (Object.prototype.hasOwnProperty.call(this.quote, 'currentStep')) {
      this.currentStep = this.steps.find((step) => step.index === this.quote.currentStep);
    }

    this.setWizardQuoteCurrentStep(this.currentStep);
  }

  public setWizardNextStep(oldIndexStep: number) {
    this.store.dispatch(wizardActions.setCompleteStep({ index: oldIndexStep }));
    this.currentStep = this.steps[oldIndexStep + 1];

    this.setWizardQuoteCurrentStep(this.currentStep);
    this.router.navigate([this.currentStep.fullPath]);
  }

  private addBlockNavigate(): boolean {
    const toPrevious = this.quote.toPrevious || false;
    return toPrevious;
  }

  public setWizardBackStep(oldIndexStep: number) {
    if (this.addBlockNavigate()) return;

    this.currentStep = this.steps[oldIndexStep - 1];
    this.setWizardQuoteCurrentStep(this.currentStep);

    this.router.navigate([this.currentStep.fullPath]);
  }

  public validateStep(routeUrl: string) {
    const { currentStep } = this.quote;

    if (currentStep) {
      // set complete previousSteps to currentStep
      this.steps.forEach((step: Step) => {
        if (step.index < currentStep) {
          this.store.dispatch(wizardActions.setCompleteStep({ index: step.index }));
        }
      });
    }

    if (this.addBlockNavigate()) {
      const summaryFullPath = this.routes.StepPricing.fullPath;
      if (`/${summaryFullPath}` !== routeUrl) {
        this.router.navigate([summaryFullPath]);
      }
    }
  }

  changeShowSteps(data) {
    this.showStepsSource.next(data);
  }

  ngOnDestroy(): void {
    if (this.stateSubscription) this.stateSubscription.unsubscribe();
    if (this.wizardStateSubscription) this.wizardStateSubscription.unsubscribe();
  }
}
